import { has } from 'lodash';
import Promise from 'bluebird';

import {
  COINMARKETCAP_ENDPOINT,
  COINMARKETCAP_ETH_ID,
  COINMARKETCAP_CAT_ID,
} from '../constants';

/**
 * Fetch the current ETH exchange rates for select fiat currencies.
 *
 * @param {array} currencyCodes
 *
 * @returns {object} the exchangeRates by currency code.
 */
export const fetchEthCurrencyExchangeRates = async currencyCodes =>
  Promise.reduce(
    currencyCodes.map(currencyCode => currencyCode.toUpperCase()),
    (exchangeRates, currencyCode) =>
      fetch(`${COINMARKETCAP_ENDPOINT}/${COINMARKETCAP_ETH_ID}/?convert=${currencyCode}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error(response.statusText ? response.statusText : 'Invalid Request');
        })
        .then((result) => {
          const { quotes } = result.data;
          return {
            ...exchangeRates,
            [currencyCode.toLowerCase()]: has(quotes, currencyCode)
              ? parseFloat(quotes[currencyCode].price)
              : 0,
          };
        }),
    {},
  );

export const fetchCatEthExchangeRate = async () =>
  fetch(`${COINMARKETCAP_ENDPOINT}/${COINMARKETCAP_CAT_ID}/?convert=ETH`)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(response.statusText ? response.statusText : 'Invalid Request');
    })
    .then((result) => {
      const { quotes } = result.data;
      return quotes.ETH ? parseFloat(quotes.ETH.price) : 0;
    });



// WEBPACK FOOTER //
// ./src/services/currencyExchangeRate.js